import type { PropsWithChildren } from 'preact/compat';
import './Drawer.less';

export type DrawerProps = PropsWithChildren<{
    side?: 'left' | 'right';
    isOpen: boolean;
    onBackdropClick?: () => void;
}>;

const Drawer = ({
    side = 'left',
    isOpen,
    onBackdropClick,
    children
}: DrawerProps) => (
    <>
        <div
            className={`bri-Drawer-backdrop ${
                isOpen ? 'bri-Drawer-backdrop-visible' : ''
            }`}
            onClick={onBackdropClick}
        />
        <div
            className={`bri-Drawer bri-Drawer-side-${side} ${
                isOpen ? 'bri-Drawer-open' : ''
            }`}
        >
            {children}
        </div>
    </>
);

export default Drawer;
